export default {"src":"/_next/static/media/VSTS.4f765e59.svg","height":18,"width":18};